export const InputWrapper = ({
  error,
  label,
  children,
}: {
  error?: string
  label: string
  children: React.ReactNode
}) => (
  <div>
    <label className={'text-xs text-tertiary'}>{label}</label>
    {children}
    {error && <p className={'text-xs font-roboto-mono text-destructive mt-1'}>{error}</p>}
  </div>
)
